/* ==========================================================================
   Admin Signup Page — Redirect to Contact Sales
   Task F33: Sales-led model replaces self-serve signup (REQ-10)
   ========================================================================== */

import { Navigate } from 'react-router-dom'

export function Signup() {
  return <Navigate to="/contact-sales" replace />
}

export default Signup
